import React, { useState } from "react";
import { useResources } from "./useResources";
import ResourceTagCheckboxes from "./ResourceTagCheckboxes";
import ResourceCard from "./ResourceCard";
import { useTranslation } from "../../i18n/LanguageProvider";

export default function Resources() {
  const { isPortuguese, t } = useTranslation();
  const text = (pt, en) => isPortuguese ? pt : en;
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const { resources, tags, activeTags, total } = useResources(searchTerm, selectedTags);
  const filtering = Boolean(searchTerm) || selectedTags.length > 0;

  const handleTagChange = (tag) => {
    setSelectedTags((previous) =>
      previous.includes(tag) ? previous.filter((item) => item !== tag) : [...previous, tag]
    );
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedTags([]);
  };

  return (
    <section>
      <h1 className="page-title">{t("resources.title")}</h1>

      <div className="publication-editorial">
        <div className="publication-filters" role="search" aria-label={t("resources.filterByTag")}>
          <label className="publication-search">
            {text("Buscar recursos", "Search resources")}
            <input
              type="search"
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
              placeholder={t("search.resourcesPlaceholder")}
            />
          </label>
        </div>

        <details className="resource-filters">
          <summary>
            {t("resources.filterByTag")}
            {selectedTags.length > 0 && ` (${selectedTags.length})`}
          </summary>
          <ResourceTagCheckboxes
            allTags={tags}
            selectedTags={selectedTags}
            activeTags={activeTags}
            onTagChange={handleTagChange}
          />
        </details>

        <div className="publication-results-summary">
          <span role="status">
            {text(`${resources.length} de ${total} recursos`, `${resources.length} of ${total} resources`)}
          </span>
          {filtering && (
            <button type="button" onClick={clearFilters}>{t("resources.clearFilters")}</button>
          )}
        </div>

        {resources.length === 0 && (
          <div className="publication-empty">
            <h2>{t("resources.noResources")}</h2>
            <p>{t("search.differentResource")}</p>
          </div>
        )}

        <div className="publication-list">
          {resources.map((resource) => (
            <ResourceCard
              key={resource.url}
              resource={resource}
              selectedTags={selectedTags}
              onTagClick={handleTagChange}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
